import { ReactNode } from "react";

import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";

type Props = {
	children: ReactNode;
};

export function ReportBaseLayout({ children }: Props) {
	return (
		<div className="p-2">
			<Row className="m-2">
				<Card>
					<Card.Body>
						{children}
					</Card.Body>
				</Card>
			</Row>
		</div>
	);
}
